import siteControllerHandlers from "./handlers/siteControllerHandlers";

export const handlers = [...siteControllerHandlers];
